var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Discount 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.05394 7.78648C1.84682 7.78648 1.65782 7.6186 1.66734 7.39915C1.7231 6.11408 1.87934 5.2775 2.31706 4.61572C2.5689 4.23499 2.8817 3.90385 3.24135 3.63725C4.21345 2.91669 5.58482 2.91669 8.32754 2.91669H11.6732C14.4158 2.91669 15.7872 2.91669 16.7593 3.63725C17.119 3.90385 17.4317 4.23499 17.6836 4.61572C18.1213 5.27743 18.2776 6.1139 18.3333 7.39871C18.3428 7.61842 18.1536 7.78648 17.9462 7.78648C16.7914 7.78648 15.8552 8.77752 15.8552 10C15.8552 11.2225 16.7914 12.2135 17.9462 12.2135C18.1536 12.2135 18.3428 12.3816 18.3333 12.6014C18.2776 13.8862 18.1213 14.7226 17.6836 15.3844C17.4317 15.765 17.119 16.0962 16.7593 16.3628C15.7872 17.0834 14.4158 17.0834 11.6732 17.0834H8.32754C5.58482 17.0834 4.21345 17.0834 3.24135 16.3628C2.8817 16.0962 2.5689 15.765 2.31706 15.3844C1.87934 14.7225 1.7231 13.8859 1.66734 12.6009C1.65782 12.3814 1.84682 12.2135 2.05394 12.2135C3.20876 12.2135 4.14493 11.2225 4.14493 10C4.14493 8.77752 3.20876 7.78648 2.05394 7.78648Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.91699 12.0834L12.0837 7.91669",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.91699 7.91669H7.92634M12.0743 12.0834H12.0837",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.889a8ed103e377ee5574978092ac9545.svg";
export { ForwardRef as ReactComponent };